(function() {
  $(() => {
    const dashboardDataSelector = '#dashboard_data';

    Object.assign(window.SOPHIA, {
      takenPracticeMilestone: function() {
        return $(dashboardDataSelector).data('takenPracticeMilestone');
      },
      riskPredictionScore: function() {
        return $(dashboardDataSelector).data('riskPredictionScore');
      },
      courseHasPracticeMilestoneAndMilestone: function() {
        return $(dashboardDataSelector).data('courseHasPracticeMilestoneAndMilestone');
      },
      linkToPracticeMilestone: function() {
        return $(dashboardDataSelector).data('linkToPracticeMilestone');
      }
    });
  });
})();
